import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { getJobId, queueJobPolling } from '@src/utility/CommonBulkPoll';
import {
  OVERPAYMENT_API_URL,
  OVERPAYMENT_GRAPH_DATA_API_URL,
  OVERPAYMENT_METRICS_API_URL,
  OVERPAYMENT_FINANCIAL_PERFORMENCE,
  OVERPAYMENT_GRAPH_DATA_API_URL_BULK,
  OVERPAYMENT_API_URL_BULK,
  OVERPAYMENT_METRICS_API_URL_BULK,
  OVERPAYMENT_FINANCIAL_PERFORMENCE_BULK,
} from './apiUrlConstants';

const _httpService = new HttpService();
const cache = new Map();

if (checkIsInternal()) {
  _httpService.setBaseURL(config('API_DOMAIN_INTERNAL') || '');
} else {
  _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL') || '');
  //_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}

const tinGroupId = sessionStorage.getItem('tinGroupId')
  ? sessionStorage.getItem('tinGroupId')
  : '';

// Helper for polling a bulk job
type PollBulkJobOptions = { onStop?: (stopFn: () => void) => void };
async function pollBulkJob<T = unknown>(
  endpoint: string,
  payload: Record<string, unknown>,
  options?: PollBulkJobOptions
): Promise<T> {
  const jobIdResponse = await getJobId(endpoint, payload);
  const jobId = jobIdResponse.Data.JobId;
  return new Promise<T>((resolve, reject) => {
    queueJobPolling(
      jobId,
      {
        onInProgress: () => {
},
        onCompleted: (result) => {
resolve(result as T);
        },
        onFailed: (errorMessage) => {
          console.error('[OverPayment] Bulk Polling - Job failed:', errorMessage);
          reject(new Error(errorMessage));
        },
        onStatusUpdate: (statusResponse) => {
},
      },
      '/job-status/result',
      1000,
      undefined,
      false
    ).then((cleanup) => {
      if (options && typeof options.onStop === 'function') {
        options.onStop(cleanup);
      }
    });
  });
}

export const getOverPaymentGraphData = async (payload: any) => {
  const url = OVERPAYMENT_GRAPH_DATA_API_URL;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData;
  } catch {
    return null;
  }
};
export const getOverPaymentBulkGraphData = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  
  try {
    return await pollBulkJob(OVERPAYMENT_GRAPH_DATA_API_URL_BULK, updatedPayload, options);
  } catch (error) {
    console.error('[OverPayment] Error in getOverPaymentBulkGraphData:', error);
    return null;
  }
};
export const getOverPaymentCardData = async (payload: any) => {
  const url = OVERPAYMENT_API_URL;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData;
  } catch {
    return null;
  }
};
export const getOverPaymentBulkCardData = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  
  try {
    return await pollBulkJob(OVERPAYMENT_API_URL_BULK, updatedPayload, options);
  } catch (error) {
    console.error('[OverPayment] Error in getOverPaymentBulkCardData:', error);
    return null;
  }
};
export const getOverPaymentCardDataPayment = async (payload: any) => {
  const url = OVERPAYMENT_METRICS_API_URL;
  try {
    const responseData: any = await _httpService.push(url, payload);
    return responseData;
  } catch {
    return null;
  }
};
export const getOverPaymentBulkCardDataPayment = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  
  try {
    return await pollBulkJob(OVERPAYMENT_METRICS_API_URL_BULK, updatedPayload, options);
  } catch (error) {
    console.error('[OverPayment] Error in getOverPaymentBulkCardDataPayment:', error);
    return null;
  }
};

// OverPayment Financial Performance Trend Graph API Call

export const getOverPaymentFinancialPerformance = async (payload: any) => {
  const url = OVERPAYMENT_FINANCIAL_PERFORMENCE;
  let finalUrl = url;

  try {
    const responseData: any = await _httpService.push(finalUrl, payload);
    return responseData;
  } catch {
    return null;
  }
};
export const getOverPaymentBulkFinancialPerformance = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = {
    TinGroupId: tinGroupId,
    ...payload,
  };
  //add bulk api url
  try {
    return await pollBulkJob(OVERPAYMENT_FINANCIAL_PERFORMENCE_BULK, updatedPayload, options);
  } catch (error) {
    console.error('[OverPayment] Error in getOverPaymentBulkFinancialPerformance:', error);
    return null;
  }
};
